import { create, doMocked, isMocked } from "../api";
import { key } from "./action";
export const SERVICE_ENDPOINT = "comment";

export const makeComment = (body) => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT);
  return create(`${SERVICE_ENDPOINT}`, body, null, false);
};
